import { render, staticRenderFns } from "./DynamicDataTable.vue?vue&type=template&id=118a3512&scoped=true"
import script from "./DynamicDataTable.vue?vue&type=script&lang=js"
export * from "./DynamicDataTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicDataTable.vue?vue&type=style&index=0&id=118a3512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a3512",
  null
  
)

export default component.exports